import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { actions } from './store/actions';
import Badge from 'commons/components/Badge';
import CardList from './CardList';
import { Container } from './styled';
import { ROUTES } from 'commons/routes/routes';

class NotificationBadge extends Component {
	state = {
		open: false
	};

	componentDidMount() {
		const { getTotalNotifications } = this.props;
		document.addEventListener('mousedown', this.handleClick, false);
		getTotalNotifications();
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClick, false);
	}

	handleClick = e => {
		const { open } = this.state;
		if (this.node.contains(e.target)) {
			return;
		}

		if (open) {
			return this.handleOpenList();
		}
	};

	handleOpenList = () => {
		const { stopPolling, getNotifications, getTotalNotifications } = this.props;
		const { open } = this.state;

		if (!open) {
			stopPolling();
			getNotifications();
			return this.setState({ open: true });
		}

		getTotalNotifications();
		return this.setState({ open: false });
	};

	handleNotifications = () => {
		const { history } = this.props;
		this.handleOpenList();
		return history.push(ROUTES.MY_NOTIFICATIONS.path);
	};

	render() {
		const { showPreloader, totalNotifications, setAnimate, notifications } = this.props;
		const { open } = this.state;

		return (
			<Container ref={node => (this.node = node)}>
				<Badge
					badgeContent={totalNotifications}
					enabled={setAnimate}
					startAnimate={setAnimate}
					onClick={this.handleOpenList}
				/>
				{open && (
					<CardList
						notifications={notifications}
						showPreloader={showPreloader}
						handleClose={this.handleNotifications}
					/>
				)}
			</Container>
		);
	}
}

NotificationBadge.defaultProps = {
	setAnimate: false,
	totalNotifications: ''
};

NotificationBadge.propTypes = {
	getNotifications: PropTypes.func.isRequired,
	getTotalNotifications: PropTypes.func.isRequired,
	stopPolling: PropTypes.func.isRequired,
	setAnimate: PropTypes.bool.isRequired,
	showPreloader: PropTypes.bool.isRequired,
	totalNotifications: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

const mapProps = state => ({ ...state.notificationsBadge, usuario: state.usuario });

export default withRouter(
	connect(
		mapProps,
		actions
	)(NotificationBadge)
);
